// extracted by mini-css-extract-plugin
module.exports = {"is-mob":"showMore_is-mob__uGTrz","is-desk":"showMore_is-desk__tYnlx","button":"showMore_button__qHng5"};